import { createContext, useContext } from 'react';

export interface AmplitudeMetadata {
  [key: string]: any;
}

// Will always be initialised by the provider below, so force casting is fine
const AmplitudeMetadataContext = createContext<AmplitudeMetadata>({} as AmplitudeMetadata);

export function useAmplitudeMetadata() {
  return useContext(AmplitudeMetadataContext);
}

interface AmplitudeMetadataContextProviderProps {
  metadata: Record<string, any>;
  children?: React.ReactNode;
}

export const AmplitudeMetadataContextProvider = ({ children, metadata }: AmplitudeMetadataContextProviderProps) => (
  <AmplitudeMetadataContext.Provider value={metadata}>{children}</AmplitudeMetadataContext.Provider>
);
